import styles from './BrandMark.module.css'

/**
 * The 19CRT mark: three teal dots that light up in turn, slowly. `size` is
 * the dot's side in px; the mark is three dots and two 3 px gaps wide.
 */
export function BrandMark({ size = 6, still = false }: { size?: number; still?: boolean }): JSX.Element {
  return (
    <span
      className={[styles.mark, still ? styles.still : ''].filter(Boolean).join(' ')}
      style={{ ['--dot' as string]: `${size}px` }}
      aria-hidden="true"
    >
      <span />
      <span />
      <span />
    </span>
  )
}
